import Directory from "../../components/directory/directory.component";

const Home = () => {

  return (
    <div className="home">
      <Directory />
    </div>
  );
}

export default Home;
